import { useTranslation } from "react-i18next";
import MyImage from "../utils/MyImage";

const ProductType = {
  SPAREPARTS: 0,
  POWERPARTS: 2,
  AFTERMARKET: 1,
  SIMILAR_OEM_PARTS: 3,
  UNKNOWN: 4,
};

export const openVariant = async (rData: any) => {
  const handle = rData.handle;
  const variantId = rData.variantId;

  if (rData?.aftermarketProductDetailUrl) {
    window.location.href = rData.aftermarketProductDetailUrl;
  } else if (handle && variantId) {
    let variantIdShort = variantId.split("gid://shopify/ProductVariant/")[1];
    if (variantIdShort === undefined) {
      variantIdShort = variantId; // todo luci fix this
    }

    const path = `/products/${handle.replaceAll(" ", "-")}?variant=${variantIdShort}`;
    const newPage = window.location.protocol + "//" + window.location.hostname + path;
    window.open(newPage, "_self");
  }
};

export const ProductCard = ({
  title,
  url,
  price,
  currencyCode,
  compareAtPrice,
  type,
  openVariant,
  inventoryQuantity,
}: {
  title: string;
  url: string;
  price: string;
  currencyCode: string;
  compareAtPrice: number | undefined;
  type: number;
  openVariant: () => void;
  inventoryQuantity: number;
}) => {
  const { t } = useTranslation();

  return (
    <div className={`flex-col ms-2`} style={{ minWidth: 200, width: 200 }}>
      <div className="flex flex-col h-full w-full items-center">
        <Image type={type} url={url} title={title} />

        <div className="flex grow text-center">
          <strong className="grow line-clamp-3 lg:text-sm text-sm">{title}</strong>
        </div>

        {inventoryQuantity > 0 ? (
          <div className="flex w-full justify-center">
            <p className="text-sm text-green-500">
              {" "}
              {t("stock_label")}: {inventoryQuantity} {inventoryQuantity > 1 ? t("stock_label_value_plural") : t("stock_label_value_singular")}
            </p>
          </div>
        ) : (
          <div className="flex w-full justify-center">
            <p className="text-sm text-red-500"> {t("out_of_stock")}</p>
          </div>
        )}

        <div className="flex-none mt-1 mb-1">
          <div className="flex justify-center">
            <p
              className={`
                ${compareAtPrice ? "text-red-500" : "text-black"}`}
            >
              {price} {currencyCode}
            </p>

            {compareAtPrice && <p className="ms-1 line-through">{compareAtPrice}</p>}
          </div>
        </div>

        <div className="flex w-full flex-none flex-col justify-end">
          <button
            className="bg-transparent text-black font-semibold py-1 px-4 rounded"
            style={{
              border: "1px solid lightgray",
            }}
            onClick={openVariant}
          >
            {t("aftermarket_card_view_button")}
          </button>
        </div>

        <div style={{ height: 10 }} />
      </div>
    </div>
  );
};

export const Badge = ({ type, sufix = "" }: { type: number; sufix?: string }) => {
  switch (type) {
    case ProductType.AFTERMARKET:
      return (
        <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-sm font-bold text-blue-700 ring-1 ring-inset ring-blue-700/10 w-full">
          Aftermarket {sufix}
        </span>
      );
    case ProductType.POWERPARTS:
      return (
        <span className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-sm font-bold text-yellow-800 ring-1 ring-inset ring-yellow-600/20 w-full">
          OEM Powerparts {sufix}
        </span>
      );
    case ProductType.SPAREPARTS:
      return (
        <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-sm font-bold text-gray-600 ring-1 ring-inset ring-gray-500/10 w-full">
          OEM Spare Parts {sufix}
        </span>
      );

    case ProductType.SIMILAR_OEM_PARTS:
      return (
        <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-sm font-bold text-gray-600 ring-1 ring-inset ring-gray-500/10 w-full">
          Similar OEM Parts {sufix}
        </span>
      );
    default:
      return null;
  }
};

const Image = ({ type, url, title }: { type: number; url: string; title: string }) => {
  return (
    <div className="relative w-full">
      {url && url.trim().length > 0 ? (
        <div style={{ height: 150, width: "auto" }}>
          <MyImage src={url} alt={title} style={{ height: "100%", width: "auto", objectFit: "cover" }} />
        </div>
      ) : (
        <div style={{ height: 150, width: "100%" }}></div>
      )}

      <div className="absolute bottom-1 left-1">
        <Badge type={type} />
      </div>
    </div>
  );
};
